import { FC } from "react";

import { type StatusIconProps, initializeStatusIconProps } from "mds/utils/images";

export const PageStatusIcon: FC<StatusIconProps> = (props) => {
  const { statusClassName, ...svgProps } = initializeStatusIconProps(props);
  return (
    <svg {...svgProps}>
      <path
        d="M14.0664 7V1H1.93311V15H7.49977"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M4.73291 3.79999H11.2662"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M4.73291 6.59998H10.7329"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M4.73291 9.40002H7.13291"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M4.73291 12.2H6.53291"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <rect className={statusClassName} height="6" rx="3" stroke="none" width="6" x="9" y="9" />
    </svg>
  );
};
